import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCopyText = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 15,
	height: 18,
	viewBox: "0 0 15 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M10.5 0.75H1.5C0.675 0.75 0 1.425 0 2.25V12.75H1.5V2.25H10.5V0.75ZM9.75 3.75L14.25 8.25V15.75C14.25 16.575 13.575 17.25 12.75 17.25H4.4925C3.6675 17.25 3 16.575 3 15.75L3.0075 5.25C3.0075 4.425 3.675 3.75 4.5 3.75H9.75ZM9 9H13.125L9 4.875V9Z",
		fill: "#05668D"
	})]
});
const ForwardRef = forwardRef(SvgCopyText);
export { ForwardRef as ReactComponent };
